export default "__VITE_ASSET__4d19458f__"